export const dataLayerPush = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(event);
  };
  
  export const trackingViewItem = (product) => {
    if (product &&
        product.items &&
        product.items.length > 0
    ) {
      dataLayerPush({
        event: 'view_item',
        ecommerce: product,
      });
    }
  };
  

 
  